import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import DownloadSection from './components/DownloadSection';
import FeatureSection from './components/FeatureSection';
import VersionSection from './components/VersionSection';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';
import ReviewSection from './components/ReviewSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/appData';

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://cpp-official.com',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://cpp-official.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'CPP官网首页 - 官方正版App下载',
    description: siteInfo.description,
    url: 'https://cpp-official.com',
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: 'https://cpp-official.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <script type="application/ld+json">{JSON.stringify(pageSchema)}</script>
      <main>
        <Navbar />
        <HeroSection />
        <DownloadSection />
        <FeatureSection />
        <VersionSection />
        <StatsSection />
        <FAQSection />
        <ReviewSection />
        <CTASection />
        <Footer />
      </main>
    </>
  );
}